// Based on react-rangeslider from whoisandy
// https://github.com/whoisandy/react-rangeslider
// MIT license

const ResizeObserver = require("resize-observer-polyfill").default;
const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");
const _ = require("lodash");

const AssetsUtil = require("../util/AssetsUtil");
const styles = require("./styles/RangeSlider.css");

/**
 * Predefined constants
 * @type {Object}
 */
const constants = {
	orientation: {
		horizontal: {
			dimension: "width",
			direction: "left",
			reverseDirection: "right",
			coordinate: "x",
		},
		vertical: {
			dimension: "height",
			direction: "top",
			reverseDirection: "bottom",
			coordinate: "y",
		},
	},
};

module.exports = createReactClass({
	displayName: "RangerSlider",

	propTypes: {
		className: PT.string,
		min: PT.number,
		max: PT.number,
		step: PT.number,
		value: PT.number,
		orientation: PT.string,
		tooltip: PT.bool,
		reverse: PT.bool,
		labels: PT.object,
		format: PT.func,
		onChangeStart: PT.func,
		onChange: PT.func,
		onChangeComplete: PT.func,
		handleClassName: PT.string,
	},

	getDefaultProps: function() {
		return {
			min: 0,
			max: 100,
			step: 1,
			value: 0,
			orientation: "horizontal",
			tooltip: true,
			reverse: false,
			labels: {},
		};
	},

	getInitialState: function() {
		return {
			active: false,
			limit: 0,
			grab: 0,
		};
	},

	componentDidMount: function() {
		this.handleUpdate();
		const resizeObserver = new ResizeObserver(this.handleUpdate);
		resizeObserver.observe(this.slider);
		// Doesn't use the component state :^(
		this.value = this.props.value;
	},

	// Update the slider when the value is changed externally
	componentDidUpdate: function(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.value = this.props.value;
			this.handleUpdate();
		}
	},

	componentWillUnmount: function() {
		document.removeEventListener("mousemove", this.handleDrag);
		document.removeEventListener("touchmove", this.handleDrag);
		document.removeEventListener("mouseup", this.handleEnd);
	},

	/**
	 * Format label/tooltip value
	 * @param  {Number} - value
	 * @return {Formatted Number}
	 */
	handleFormat: function(value) {
		const {format} = this.props;
		return format ? format(value) : value;
	},

	/**
	 * Update slider state on change
	 * @return {void}
	 */
	handleUpdate: function() {
		if (!this.slider) {
			// for shallow rendering
			return;
		}
		const {orientation} = this.props;
		const dimension = _.capitalize(
			constants.orientation[orientation].dimension
		);
		const sliderPos = this.slider[`offset${dimension}`];
		const handlePos = this.handle[`offset${dimension}`];
		// TODO: There's some weird stuff going on here, the left edge and right edge of the slider are not symmetrical
		this.setState({
			limit: sliderPos - handlePos / 2,
			grab: handlePos / 2,
		});
	},

	/**
	 * Attach event listeners to mousemove/mouseup events
	 * @return {void}
	 */
	handleStart: function(e, isTouch) {
		const {onChangeStart} = this.props;
		const moveEvent = isTouch ? "touchmove" : "mousemove";
		document.addEventListener(moveEvent, this.handleDrag);
		document.addEventListener("mouseup", this.handleEnd);
		this.setState(
			{
				active: true,
			},
			() => {
				onChangeStart && onChangeStart(e);
			}
		);
	},

	/**
	 * Handle drag/mousemove event
	 * @param  {Object} e - Event object
	 * @return {void}
	 */
	handleDrag: function(e) {
		e.stopPropagation();
		const {onChange} = this.props;
		const {
			target: {className, classList, dataset},
		} = e;
		if (!onChange || className === styles.labels) return;

		let value = this.position(e);

		if (classList && classList.contains(styles.labelItem) && dataset.value) {
			value = parseFloat(dataset.value);
		}
		this.value = value;
		onChange && onChange(value, e);
	},

	handleStartAndDrag: function(e) {
		this.handleStart(e, false);
		this.handleDrag(e);
	},

	handleTouchStartAndDrag: function(e) {
		this.handleStart(e, true);
		this.handleDrag(e);
	},

	/**
	 * Detach event listeners to mousemove/mouseup events
	 * @return {void}
	 */
	handleEnd: function(e) {
		const {onChangeComplete} = this.props;
		this.setState(
			{
				active: false,
			},
			() => {
				onChangeComplete && onChangeComplete(e);
			}
		);
		document.removeEventListener("mousemove", this.handleDrag);
		document.removeEventListener("touchmove", this.handleDrag);
		document.removeEventListener("mouseup", this.handleEnd);
	},

	/**
	 * Support for key events on the slider handle
	 * @param  {Object} e - Event object
	 * @return {void}
	 */
	handleKeyDown: function(e) {
		e.preventDefault();
		const {keyCode} = e;
		const {value, min, max, step, onChange} = this.props;
		let sliderValue;

		switch (keyCode) {
			case 38:
			case 39:
				sliderValue = value + step > max ? max : value + step;
				onChange && onChange(sliderValue, e);
				break;
			case 37:
			case 40:
				sliderValue = value - step < min ? min : value - step;
				onChange && onChange(sliderValue, e);
				break;
		}
	},

	setValue: function(value) {
		this.value = value;
	},

	/**
	 * Calculate position of slider based on its value
	 * @param  {number} value - Current value of slider
	 * @return {position} pos - Calculated position of slider based on value
	 */
	getPositionFromValue: function(value) {
		const {limit} = this.state;
		const {min, max} = this.props;
		const diffMaxMin = max - min;
		const diffValMin = value - min;
		const percentage = diffValMin / diffMaxMin;
		const pos = Math.round(percentage * limit);

		return pos;
	},

	/**
	 * Translate position of slider to slider value
	 * @param  {number} pos - Current position/coordinates of slider
	 * @return {number} value - Slider value
	 */
	getValueFromPosition: function(pos) {
		const {limit} = this.state;
		const {orientation, min, max, step} = this.props;
		const percentage = _.clamp(pos, 0, limit) / (limit || 1);
		const baseVal = step * Math.round((percentage * (max - min)) / step);
		const value = orientation === "horizontal" ? baseVal + min : max - baseVal;

		return _.clamp(value, min, max);
	},

	/**
	 * Calculate position of slider based on value
	 * @param  {Object} e - Event object
	 * @return {number} value - Slider value
	 */
	position: function(e) {
		const {grab} = this.state;
		const {orientation, reverse} = this.props;

		const node = this.slider;
		// This function has fired when this.slider was null, perhaps because
		// a drag event fired after this element unmounted. This should prevent
		// an error in that scenario.
		if (!node) {
			return this.value;
		}
		const coordinateStyle = constants.orientation[orientation].coordinate;
		const directionStyle = reverse
			? constants.orientation[orientation].reverseDirection
			: constants.orientation[orientation].direction;
		const clientCoordinateStyle = `client${_.capitalize(coordinateStyle)}`;
		const coordinate = !e.touches
			? e[clientCoordinateStyle]
			: e.touches[0][clientCoordinateStyle];
		const direction = node.getBoundingClientRect()[directionStyle];
		const pos = reverse
			? direction - coordinate - grab
			: coordinate - direction - grab;
		const value = this.getValueFromPosition(pos);

		return value;
	},

	/**
	 * Grab coordinates of slider
	 * @param  {Object} pos - Position object
	 * @return {Object} - Slider fill/handle coordinates
	 */
	coordinates: function(pos) {
		const {limit, grab} = this.state;
		const {orientation} = this.props;
		const handlePos = orientation === "horizontal" ? pos + grab : pos;
		const fillPos =
			orientation === "horizontal" ? handlePos : limit - handlePos;
		return {
			fill: fillPos,
			handle: handlePos,
			label: handlePos,
		};
	},

	renderLabels: function(labels) {
		return (
			<ul
				ref={sl => {
					this.labels = sl;
				}}
				className={styles.labels}
			>
				{labels}
			</ul>
		);
	},

	render: function() {
		const {
			orientation,
			className,
			tooltip,
			reverse,
			labels,
			min,
			max,
			handleClassName,
		} = this.props;
		const value = this.value;
		const {active} = this.state;
		const dimension = constants.orientation[orientation].dimension;
		const direction = reverse
			? constants.orientation[orientation].reverseDirection
			: constants.orientation[orientation].direction;
		const position = this.getPositionFromValue(value);
		const coords = this.coordinates(position);
		const fillStyle = {[dimension]: `${coords.fill}px`};
		const handleStyle = {[direction]: `${coords.handle}px`};
		const showTooltip = tooltip && active;

		const labelItems = [];
		let labelKeys = Object.keys(labels);

		if (labelKeys.length > 0) {
			labelKeys = labelKeys.sort((a, b) => (reverse ? a - b : b - a));

			for (const key of labelKeys) {
				const labelPosition = this.getPositionFromValue(key);
				const labelCoords = this.coordinates(labelPosition);
				const labelStyle = {[direction]: `${labelCoords.label}px`};

				labelItems.push(
					<li
						key={key}
						className={styles.labelItem}
						data-value={key}
						onMouseDown={this.handleDrag}
						onTouchStart={this.handleStart}
						onTouchEnd={this.handleEnd}
						style={labelStyle}
					>
						{labels[key]}
					</li>
				);
			}
		}

		const reverseClass = reverse ? "reverse" : "";
		const classNames = `${styles.main} ${styles[orientation]} ${className} ${reverseClass}`;

		let handleClass = styles.handle;
		if (handleClassName) {
			handleClass += ` ${handleClassName}`;
		}

		return (
			<div
				ref={s => {
					this.slider = s;
				}}
				className={classNames}
				onMouseDown={this.handleStartAndDrag}
				onMouseUp={this.handleEnd}
				onTouchStart={this.handleTouchStartAndDrag}
				onTouchEnd={this.handleEnd}
				aria-valuemin={min}
				aria-valuemax={max}
				aria-valuenow={this.value}
				aria-orientation={orientation}
			>
				<div className={styles.fill} style={fillStyle} />
				<div
					ref={sh => {
						this.handle = sh;
					}}
					className={handleClass}
					onTouchMove={this.handleDrag}
					onTouchEnd={this.handleEnd}
					onKeyDown={this.handleKeyDown}
					style={handleStyle}
					tabIndex={0}
				>
					{showTooltip ? (
						<div
							ref={st => {
								this.tooltip = st;
							}}
							className={styles.handleTooltip}
						>
							<span>{this.handleFormat(this.value)}</span>
						</div>
					) : null}
					<div className={styles.handleIconWrapper}>
						<img
							className={styles.handleIcon}
							src={AssetsUtil.getTrainerElement("range-slider-handle")}
						/>
					</div>
				</div>
				{labels ? this.renderLabels(labelItems) : null}
			</div>
		);
	},
});
